import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import { isBrowser, useScript } from '@jelly/utils'

// Styled Components via Emotion
const IframeWrapper = styled.div`
	width: 100%;
	height: ${({ page }) => (page === 'connect' ? '100%' : '448px')};
	overflow: hidden;

	${({ theme }) => theme.MQ.S} {
		height: ${({ page }) => (page === 'connect' ? '100%' : '365px')};
	}

	${({ theme }) => theme.MQ.L} {
		height: ${({ page }) => (page === 'connect' ? '100%' : '400px')};
		width: ${({ page }) => {
			if (page !== 'connect') {
				return '100%'
			} else {
				return '50%'
			}
		}};
	}
	${({ theme }) => theme.MQ.XL} {
		height: ${({ version, page }) => {
			if (page !== 'connect') {
				return version === 'v1' ? '400px' : '600px'
			} else {
				return '100%'
			}
		}};
`

PardotForm.propTypes = {
	height: string,
	src: string.isRequired,
	title: string,
	width: string,
}

/**
 * This Component is the PardotForm
 * The fields and styles are controlled via Salesforce
 */
function PardotForm({ height, src, title = 'Pardot Form', width, page, version }) {
	if (isBrowser()) {
		window.piAId = '901901'
		window.piCId = '3311'
		window.piHostname = 'pi.pardot.com'
	}
	useScript('https://pi.pardot.com/pd.js')

	return (
		<IframeWrapper id="pardot-form" version={version} page={page}>
			<iframe
				allowtransparency="true"
				frameBorder="0"
				height={height}
				src={src}
				style={{ border: 0 }}
				title={title}
				type="text/html"
				width={width}
			></iframe>
		</IframeWrapper>
	)
}

export default PardotForm
